import type { TFunction } from 'i18next'

/** Localized short label for a condition rating badge. */
export function conditionLabel(condition: string, t: TFunction): string {
  return t(`listing.condition.${condition}`, condition)
}
